import {DigiposService} from "@/services/digipos.service"

const state ={
  soon: false,
  loading: false,
  overlay: false,
  loadingAddKategori: false,
  loadingMenuDeleteAkun: false,
  modal_aktivasi: false,
  digiposts: [],
  totaldata: 1,
  totalpage: 1,
  count: 0
}

const actions = {
  getDigiposData({commit}){
    commit('setloading',true);
    if(state.digiposts.length !== 0) commit('setPendings',[]);
    DigiposService.getDigipostUrl().then(data => {
      commit("setDigiposts", data)
      commit('setloading',false);
    }).catch(err => {
      console.log(err)
      commit('setloading',false);
    })
  },

  openCloseModal({commit}){
    commit("setModalBoolean", !state.modal_aktivasi)
  },

  updateUrlModule({commit, dispatch},opt){
    commit("setModalBoolean", !state.modal_aktivasi)
    if(!opt.url_module) dispatch('alert/error', "Url module tidak boleh kosong", { root: true });
    else{
      commit('setloading',true);
      commit("setDigiposts", [])
      DigiposService.updateUrlModule(opt).then (data => {
        dispatch('alert/success', data.msg, { root: true });
        DigiposService.getDigipostUrl().then(data => {
          commit("setDigiposts", data)
          commit('setloading',false);
        }).catch(err => {
          console.log("=====ERROR getDigipostUrl=====")
          console.log(err)
        })
      }).catch(err => {
        dispatch('alert/error', "Internal server error", { root: true });
        console.log("=====ERROR updateUrlModule=====")
        console.log(err)
      })
    }
  }
}

const mutations = {
  setDigiposts(state, value){
    state.digiposts = value.data;
  },
  setloading(state,load) {
    state.loading = load
    state.overlay = load
  },
  setPendingCount(state,load){
    state.count = load
  },
  setPendings(state,load){
    state.digiposts=load
  },
  setModalBoolean(state,load){
    state.modal_aktivasi = load
  }
}

export const Digipos = {
  namespaced: true,
  state,
  actions,
  mutations
};
